<template>
  <a-layout id="main">
    <a-layout-sider :trigger="null" collapsible v-model="collapsed">
      <div v-if="collapsed" class="logo logo-text">IOC</div>
      <div v-else class="logo logo-text">IOC ELMS Web Monitor</div>
      <a-menu theme="dark" mode="inline" :defaultSelectedKeys="[$route.name]">
        <a-menu-item key="Charging Report">
          <router-link to="ChargingReport">
            <a-icon type="file-excel" />
            <span>
              Charging Report
            </span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="AC Current Chart">
          <router-link to="ACCurrentChart">
            <a-icon type="line-chart" />
            <span>
              AC Current Chart
            </span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="Alert Report">
          <router-link to="AlertReport">
            <a-icon type="warning" />
            <span>
              Alert Report
            </span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="Charger Status Monitor">
          <router-link to="ChargerStatusMonitor">
            <a-icon type="monitor" />
            <span>
              Charger Status
            </span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="Connection History">
          <router-link to="ConnectionHistory">
            <a-icon type="api" />
            <span>
              Connection History
            </span>
          </router-link>
        </a-menu-item>
        <!-- <a-menu-item v-if="false" key="Energy Report">
          <router-link to="EnergyReport">
            <a-icon type="file-excel" />
            <span>
              Energy Report
            </span>
          </router-link>
        </a-menu-item> -->
        <a-menu-item key="Configure" v-if="AccessGroups.includes('developer')">
          <router-link to="Configure">
            <a-icon type="setting" />
            <span>
              Configure
            </span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="Customer Configure" v-else>
          <router-link to="CustomerConfigure">
            <a-icon type="setting" />
            <span>
              Configure
            </span>
          </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="() => (collapsed = !collapsed)"
        />
        <span>
          <b>{{ $route.name }}</b>
        </span>
        <span class="action-wrapper">
          <a-dropdown placement="bottomCenter">
            <span class="action ant-dropdown-link user-dropdown-menu">
              <a-avatar size="small" icon="user" />
              <span> {{ UserName }} </span>
              <a-icon type="down" />
            </span>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-menu-item key="1" @click="LogOut()"> <a-icon type="logout" /> Logout </a-menu-item>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-layout-header>
      <a-layout-content
        class="charging-content"
        :style="{
          margin: '24px 16px',
          padding: '20px',
          background: '#fff',
          minHeight: '280px',
          overflow: 'auto'
        }"
      >
        <router-view></router-view>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      collapsed: false,
      polling: null,
      tokenExpiryTime: null
    };
  },

  computed: {
    ...mapState(["UserPool", "IdToken", "UserName", "CognitoUser", "AccessGroups"])
  },

  created() {
    // start the loop to refresh tokens automatically on expiration.
    this.startLoop();
    if (this.IdToken) {
      axios.defaults.headers.common["Authorization"] = this.IdToken;
    } else {
      this.$message.error("Please sign in!");
      setTimeout(() => {
        this.$router.push({ path: "/login" });
      }, 2000);
    }
  },

  beforeDestroy() {
    clearInterval(this.polling);
    sessionStorage.clear();
  },

  methods: {
    ...mapMutations(["saveIdToken"]),

    LogOut() {
      this.UserPool.getCurrentUser().signOut();
      this.saveIdToken(null);
      this.$router.push({ path: "/login" });
    },

    refreshTokens() {
      if (this.CognitoUser) {
        this.CognitoUser.getSession((error, session) => {
          if (error) {
            this.$message.error(error);
          } else if (!session.isValid()) {
            this.$message.error("Please sign in!");
            setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 2000);
          } else {
            var IdToken = session.getIdToken().getJwtToken();
            axios.defaults.headers.common["Authorization"] = IdToken;
            this.saveIdToken(IdToken);
            var expTime = session.getIdToken().payload["exp"];
            this.tokenExpiryTime = new Date(expTime * 1000);
          }
        });
      }
    },

    startLoop() {
      // call refreshTokens before starting the loop in orderto retrieve the expiryTime of the current access tokens..
      this.refreshTokens();
      // in each iteration, check if access token has expired, and call refreshTokens if so.
      this.polling = setInterval(
        function() {
          var currentTime = new Date();
          if (currentTime >= this.tokenExpiryTime) {
            this.refreshTokens();
          }
        }.bind(this),
        10000
      );
    }
  }
};
</script>

<style lang="less">
#main {
  height: 100%;

  .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
  }

  .logo-text {
    color: white;
    text-align: center;
    line-height: 32px;
    font-weight: bold;
    font-size: 14px;
  }

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
    & :hover {
      color: #1890ff;
    }
  }

  .action-wrapper {
    float: right;
    margin-right: 16px;
  }
}

.ant-advanced-search-form {
  padding: 20px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow-x: auto;
  min-width: 1200px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

.ant-form {
  max-width: none;
}

.search-result-list {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow-x: auto;
  min-width: 1200px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
